import { Router, ActivatedRoute } from '@angular/router';
import { SponsorInfo } from './../../../../data/SponsorInfo';
import { CompetitionInfo } from './../../../../data/competition-data';
import { RemoteHttpService } from './../../../../remote-http';
import { isPresent } from 'src/providers/common-service';
import { NavController, NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  CompetitionData,
  CompetitionSponsorData,
  CompetitionSponsorInfo,
} from 'src/data/mygolf.data';
@Component({
  selector: 'app-competition-sponsors',
  templateUrl: './competition-sponsors.page.html',
  styleUrls: ['./competition-sponsors.page.scss'],
})
export class CompetitionSponsorsPage implements OnInit {
  public competition: CompetitionInfo & CompetitionData;
  public show: boolean = false;
  public sponsors: Array<CompetitionSponsorInfo & CompetitionSponsorData> = new Array<
    CompetitionSponsorInfo & CompetitionSponsorData
  >();

  compId: number;
  // constructor(private router: Router) {}
  constructor(
    private nav: NavController,
    private navParams: NavParams,
    private http: RemoteHttpService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.sponsors = this.router.getCurrentNavigation().extras.state.sponsors;

    this.show = isPresent(this.sponsors) ? true : false;
  }

  ngOnInit() {
    if (this.sponsors?.length) {
      this.sponsors?.sort((a, b) => {
        return a?.displaySequence - b?.displaySequence;
      });
    }
  }
  onBackpage() {
    this.location.back();
  }
  onHomeClick() {
    this.router.navigate(['tabs/player-home'], { replaceUrl: true });
  }
  getSponsorImage(s: CompetitionSponsorInfo) {
    if (!s) return;
    if (s?.imageUrl) return s.imageUrl;
    else if (s?.sponsor?.image) return s.sponsor.image;
  }
}
